/* rd-pdp.js — Radilum product page 2.0 (2026-09-20, r2 2026-09-21). Progressive enhancements on top of Honey's product sections:
   gallery thumbnails collapse to 2 rows, details jump-nav + scrollspy, Downloads block (metafields + links harvested from the
   description), coupon copy, payment icons expander, wishlist/ask-a-designer row, recently-viewed row (localStorage),
   floating widgets kept clear of the mobile sticky add-to-cart bar. Idempotent: init() may run again after Honey
   re-renders product-information (sibling product swap). No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'rdp-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }
  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); res(); } catch (e) { rej(e); }
      document.body.removeChild(ta);
    });
  }

  /* ---------- 1. gallery thumbnails: 2 rows + "view all" ---------- */
  function initThumbs() {
    $$('.product-single__thumbnails').forEach(function (ul) {
      if (ul.dataset.rdpThumbs) return;
      var items = $$('.product-single__thumbnails-item', ul);
      var limit = window.innerWidth < 750 ? 12 : 18;
      if (items.length <= limit) { ul.dataset.rdpThumbs = 'n'; return; }
      ul.dataset.rdpThumbs = 'y'; ul.classList.add('rdp-thumbs-collapsed');
      var li = document.createElement('li'); li.className = 'rdp-thumbs-more'; li.setAttribute('role', 'button'); li.tabIndex = 0;
      li.textContent = (ul.dataset.rdpViewAll || 'View all') + ' ' + items.length;
      var open = function () { ul.classList.remove('rdp-thumbs-collapsed'); li.remove(); };
      li.addEventListener('click', open); li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
      ul.appendChild(li);
    });
  }

  /* ---------- 1b. slab photo picker: 3 rows + "show all N" ---------- */
  function initSlabs() {
    $$('.rdp-slab .single-option-selector--box').forEach(function (box) {
      if (box.dataset.rdpSlabs) return;
      var items = $$('.single-option-selector__wrap-option', box); var limit = 15;
      if (items.length <= limit) { box.dataset.rdpSlabs = 'n'; return; }
      box.dataset.rdpSlabs = 'y';
      var checked = box.querySelector('input:checked'); var idx = checked ? items.indexOf(checked.closest('.single-option-selector__wrap-option')) : 0;
      if (idx >= limit) return;   // selected slab is beyond the fold → leave expanded
      box.classList.add('rdp-slab--collapsed');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rdp-slab-more'; b.textContent = (box.dataset.rdpShowAll || 'Show all') + ' ' + items.length;
      b.addEventListener('click', function () { box.classList.remove('rdp-slab--collapsed'); b.remove(); });
      box.appendChild(b);
    });
  }

  /* ---------- 2. coupon copy + payment expander + wishlist row ---------- */
  function initBuyBox() {
    $$('[data-rdp-copy]').forEach(function (b) {
      if (b.dataset.rdpBound) return; b.dataset.rdpBound = '1';
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-rdp-copy'); var old = b.textContent;
        copyText(code).then(function () { b.classList.add('is-done'); b.textContent = b.dataset.rdpDone || 'Copied'; toast((b.dataset.rdpToast || 'Code copied') + ' · ' + code); setTimeout(function () { b.classList.remove('is-done'); b.textContent = old; }, 2600); })
          .catch(function () { toast(code); });
      });
    });
    $$('.rdp-pay__tg').forEach(function (b) {
      if (b.dataset.rdpBound) return; b.dataset.rdpBound = '1';
      b.addEventListener('click', function () { b.closest('.rdp-pay').classList.add('is-open'); });
    });
    // Swym "Add to wishlist" (injected into the product form by the app) → move it beside "Ask a designer"
    var slot = $('.rdp-actions .rdp-wlslot');
    if (slot && !slot.dataset.rdpWatch) {
      slot.dataset.rdpWatch = '1';
      var tries = 0;
      var tick = function () {
        // prefer the Wishlist Plus app block (templates that have it); Swym hides its own injected bar in that case
        var appBtn = $('.product-page-section #swym-atw-button-container, .product-page-section .swym-atw-button-container');
        if (appBtn && !slot.contains(appBtn)) { slot.appendChild(appBtn); slot.classList.add('rdp-wlslot--app'); return; }
        var bar = $('.product-page-section .swym-button-bar, .product-page-section .swym-btn-container');
        if (!appBtn && bar && !slot.contains(bar)) { var root = bar.closest('.swym-button-bar') || bar; slot.appendChild(root); return; }
        if (slot.children.length) return;
        if (++tries < 60) setTimeout(tick, 500);
      };
      tick();
    }
  }

  /* ---------- 3. details column: Downloads block, plain-description polish, jump-nav, scrollspy ---------- */
  var DL_WORDS = /^(spec ?sheets?|specification(s)?|installation( guide)?|install(ation)? guide|instruction(s)?|downloads?|documents?|3d ?(model|files?)|user manual|manual|dimension drawings?)$/i;
  var NAV_SKIP = /^(share|reviews?)$/i;
  function labelOf(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function niceLabel(t) {
    t = t.replace(/[:：]+$/, '').trim();
    if (t.length > 26) t = t.slice(0, 24).replace(/\s+\S*$/, '') + '…';
    if (t === t.toUpperCase() && t.replace(/[^a-z]/gi, '').length > 4) return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function docKind(t) {
    t = (t || '').toLowerCase();
    if (/spec/.test(t)) return 'spec';
    if (/install|assembl|instruction|manual|guide/.test(t)) return 'asm';
    if (/3d|step|dwg|model/.test(t)) return '3d';
    if (/drawing|dimension/.test(t)) return 'dim';
    return '';
  }
  function isDocHref(href) {
    return /^https?:/i.test(href) && (/(drive|docs)\.google\.com|dropbox\.com|1drv\.ms|box\.com|cdn\.shopify\.com/i.test(href) || /\.(pdf|zip|rar|7z|step|stp|dwg|dxf|skp|obj|fbx|3ds|max)(\?|$)/i.test(href));
  }
  function docId(href) { var m = /\/d\/([\w-]{10,})/.exec(href); return m ? 'gd:' + m[1] : href.replace(/[?#].*$/, ''); }
  function visibleLink(a) { return !!(a.querySelector('img') || labelOf(a)); }
  /* download links still living inside the description → { found:[{kind,href,label}], removals:[elements] } */
  function harvestDocs(desc) {
    var found = [], removals = [];
    function add(kind, href, label) { if (isDocHref(href)) found.push({ kind: kind, href: href, label: label }); }
    // A+ (.pd-dl) and rd-pdp (.dl-row) button rows, with their "Downloads" label and the divider above
    $$('.pd-dl, .dl-row', desc).forEach(function (box) {
      var links = $$('a[href]', box).filter(visibleLink); if (!links.length) return;
      links.forEach(function (a) { var t = labelOf(a).replace(/^[↓⬇]\s*/, ''); add(docKind(t), a.href, t); });
      removals.push(box);
      var prev = box.previousElementSibling;
      if (prev && (prev.classList.contains('pd-label') || prev.classList.contains('section-label')) && /download|document|file/i.test(labelOf(prev))) {
        removals.push(prev);
        var div = prev.previousElementSibling;
        if (div && /(^|\s)(pd-divider|divider)(\s|$)/.test(div.className || '')) removals.push(div);
      }
    });
    // plain bodies: "SPEC SHEET / INSTALLATION / 3D FILES" headings, each followed by paragraphs holding the links
    $$('h2, h3, h4', desc).forEach(function (h) {
      var t = labelOf(h); if (!DL_WORDS.test(t)) return;
      var kind = docKind(t), nx = h.nextElementSibling, group = [h], links = [];
      // some bodies wrap the icon link in its own <h2> right after the label heading → treat text-less headings holding a link as content
      while (nx && (!/^H[1-4]$/.test(nx.tagName) || (!labelOf(nx) && nx.querySelector('a[href]')))) {
        var as = $$('a[href]', nx).filter(visibleLink);
        as.forEach(function (a) { links.push({ kind: kind || docKind(labelOf(a)), href: a.href, label: t }); });
        if (as.length || !labelOf(nx)) group.push(nx);   // paragraphs of plain text under the heading stay
        nx = nx.nextElementSibling;
      }
      if (!links.length) return;   // heading without any link: leave the body untouched
      links.forEach(function (l) { add(l.kind, l.href, l.label); });
      group.forEach(function (el) { removals.push(el); });
    });
    return { found: found, removals: removals };
  }
  function docCard(kind, href, title, sub) {
    var a = document.createElement('a'); a.href = href; a.target = '_blank'; a.rel = 'noopener'; a.setAttribute('data-rdp-doc', kind || 'other');
    var i = document.createElement('i'); i.textContent = kind === '3d' ? '3D' : kind === 'dim' ? 'DWG' : 'PDF';
    var d = document.createElement('div'); var b = document.createElement('b'); b.textContent = title; var sp = document.createElement('span'); sp.textContent = sub;
    d.appendChild(b); d.appendChild(sp); a.appendChild(i); a.appendChild(d); return a;
  }
  /* Downloads block (product-content rd_downloads): metafield cards rendered by Liquid + description links merged in; the
     description's own download sections are removed only once every link they held is in the block */
  function initDocs(desc) {
    var block = $('[data-rdp-docs]'); if (!block) return polishPlainDocs(desc);
    if (block.dataset.rdpDocsDone) return; block.dataset.rdpDocsDone = '1';
    var list = $('[data-rdp-docs-list]', block); if (!list) return; var ids = {}; var perKind = {};
    $$('a[href]', list).forEach(function (a) { ids[docId(a.href)] = 1; var k = a.getAttribute('data-rdp-doc') || 'other'; perKind[k] = (perKind[k] || 0) + 1; });
    // 0922 老板(VK 同案): metafield 槽位是唯一真源 —— 该类型 metafield 已有文件时, 描述里残留的同类型旧链接不再并入; data-rdp-hide「类型,类型」= 明确隐藏
    var mfKinds = {}; Object.keys(perKind).forEach(function (k) { if (k !== 'other') mfKinds[k] = 1; });
    (block.dataset.rdpHide || '').split(',').forEach(function (k) { k = k.trim().toLowerCase(); if (k) { mfKinds[k] = 1; mfKinds['label:' + k] = 1; } });
    var labels = { spec: block.dataset.rdpLSpec || 'Spec sheet', asm: block.dataset.rdpLAsm || 'Installation guide', '3d': block.dataset.rdpL3d || '3D files', dim: block.dataset.rdpLDim || 'Dimension drawing' };
    var sub = block.dataset.rdpDownload || 'Download';
    if (desc && !desc.dataset.rdpHarvest) {
      desc.dataset.rdpHarvest = '1';
      var r = harvestDocs(desc); var missing = 0;
      var GENERIC = /^(spec ?sheets?|specifications?|install(ation)?( guide)?|instructions?|3d ?(files?|models?)|downloads?|documents?|dimension drawings?)$/i;
      var titles = {}; $$('b', list).forEach(function (b) { titles[labelOf(b).toLowerCase()] = 1; });
      r.found.forEach(function (f) {
        var id = docId(f.href); if (ids[id]) return; ids[id] = 1;
        var k = f.kind || 'other'; if (k !== 'other' && mfKinds[k]) return; if (mfKinds['label:' + (f.label || '').replace(/^[↓⬇]\s*/, '').trim().toLowerCase()]) return; perKind[k] = (perKind[k] || 0) + 1;
        var raw = (f.label || '').replace(/^[↓⬇]\s*/, '').trim();
        // a label that says more than the generic kind word ("Install Guide (FR)", "Install Guide 2") is kept as the card title
        var title = raw && !GENERIC.test(raw) ? niceLabel(raw) : (labels[k] || niceLabel(raw || 'Document'));
        if (titles[title.toLowerCase()]) title += ' ' + perKind[k];
        titles[title.toLowerCase()] = 1;
        list.appendChild(docCard(k, f.href, title, sub));
      });
      // every harvested link is now a card → the description's copies can go
      r.found.forEach(function (f) { if (!ids[docId(f.href)]) missing++; });
      if (!missing) r.removals.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    }
    if ($$('a[href]', list).length || $('[data-rdp-dims]', block)) { block.hidden = false; if (!block.hasAttribute('data-rdp-anchor')) block.setAttribute('data-rdp-anchor', block.dataset.rdpHeading || 'Downloads'); }
    else { block.hidden = true; block.removeAttribute('data-rdp-anchor'); }
    initDims(block);
  }
  /* r3 (2026-09-21): dimension drawings strip → lightbox (prev/next/esc), no external library */
  /* 0921 老板: 尺寸图条不重复描述里已有的线稿(同文件名 → 隐藏该缩略图;全都重复 → 整条隐藏),缩略图不裁剪、居中、点开大图 */
  function __dimStem(u) { u = String(u || '').split('?')[0].split('/').pop().toLowerCase().replace(/\.(jpe?g|png|webp|gif|avif)$/, ''); return u.replace(/_(\d+x\d*|\d*x\d+)(_crop_[a-z]+)?$/, '').replace(/_(small|medium|large|grande|compact|icon|thumb)$/, ''); }
  function __dimDedupe(wrapSel, thumbSel, block) {
    var wrap = $(wrapSel, block); if (!wrap) return 0; var have = {};
    $$('.rte img, [class*="description"] img, [class*="Description"] img, .vkr6 img, .dim img, .product-single__description img', document).forEach(function (im) { if (wrap.contains(im)) return; var s = __dimStem(im.getAttribute('src') || im.getAttribute('data-src') || im.currentSrc); if (s) have[s] = 1; });
    var shown = 0; $$(thumbSel, wrap).forEach(function (a) { var im = $('img', a); var s = __dimStem((im && (im.getAttribute('src') || im.getAttribute('data-src'))) || a.getAttribute('href')); if (s && have[s]) { a.hidden = true; a.style.display = 'none'; } else shown++; });
    if (!shown) { wrap.hidden = true; wrap.style.display = 'none'; } else { var n = $('[class$="__n"]', wrap); if (n) n.textContent = shown; }
    return shown;
  }
  function initDims(block) {
    __dimDedupe('[data-rdp-dims]', 'a[data-rdp-dim]', block); var thumbs = $$('[data-rdp-dims] a[data-rdp-dim]', block).filter(function (a) { return !a.hidden; }); if (!thumbs.length || block.dataset.rdpDims) return; block.dataset.rdpDims = '1';
    var lb = document.createElement('div'); lb.className = 'rdp-lb'; lb.hidden = true; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button type="button" class="rdp-lb__x" aria-label="Close">✕</button><button type="button" class="rdp-lb__prev" aria-label="Previous">‹</button><img alt=""><button type="button" class="rdp-lb__next" aria-label="Next">›</button><p class="rdp-lb__cap"></p>';
    document.body.appendChild(lb); var img = $('img', lb), cap = $('.rdp-lb__cap', lb), cur = 0;
    function show(i) { cur = (i + thumbs.length) % thumbs.length; img.src = thumbs[cur].getAttribute('href'); img.alt = $('img', thumbs[cur]).alt || ''; cap.textContent = (cur + 1) + ' / ' + thumbs.length; lb.hidden = false; document.documentElement.classList.add('rdp-lb-open'); }
    function hide() { lb.hidden = true; document.documentElement.classList.remove('rdp-lb-open'); }
    thumbs.forEach(function (a, i) { a.addEventListener('click', function (e) { e.preventDefault(); show(i); }); });
    $('.rdp-lb__x', lb).addEventListener('click', hide); $('.rdp-lb__prev', lb).addEventListener('click', function () { show(cur - 1); }); $('.rdp-lb__next', lb).addEventListener('click', function () { show(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) hide(); });
    document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') hide(); else if (e.key === 'ArrowLeft') show(cur - 1); else if (e.key === 'ArrowRight') show(cur + 1); });
    if (thumbs.length < 2) { $('.rdp-lb__prev', lb).hidden = true; $('.rdp-lb__next', lb).hidden = true; }
  }
  /* templates without the block (legacy): plain bodies still get one DOWNLOADS row of cards in place of the icon links */
  function polishPlainDocs(desc) {
    if (!desc || desc.dataset.rdpHarvest || !desc.classList.contains('rdp-plain')) return; desc.dataset.rdpHarvest = '1';
    var r = harvestDocs(desc); if (!r.found.length) return;
    var firstH = r.removals.filter(function (el) { return /^H[1-4]$/.test(el.tagName); })[0]; if (!firstH) return;
    var row = document.createElement('div'); row.className = 'rdp-dl'; var perKind = {};
    r.found.forEach(function (f) { var k = f.kind || 'other'; perKind[k] = (perKind[k] || 0) + 1; var title = { spec: 'Spec sheet', asm: 'Install guide', '3d': '3D files', dim: 'Dimension drawing' }[k] || niceLabel(f.label); if (perKind[k] > 1) title += ' ' + perKind[k]; row.appendChild(docCard(k, f.href, title, desc.dataset.rdpDownload || 'Download')); });
    r.removals.forEach(function (el) { if (el !== firstH && el.parentNode) el.parentNode.removeChild(el); });
    firstH.textContent = desc.dataset.rdpDownloads || 'Downloads'; firstH.parentNode.insertBefore(row, firstH.nextSibling);
  }
  function polishPlain(desc) {
    if (desc.dataset.rdpPolished) return; desc.dataset.rdpPolished = '1';
    var isAplus = !!(desc.querySelector('.pd-label, .rd-pdp, .section-label, .pd-spec-table, .spec-table, [class^="pd-"], [class*=" pd-"]'));
    if (!isAplus) desc.classList.add('rdp-plain');
  }
  function headerOffset() {
    var h = $('.shopify-section-header, #shopify-section-header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if ((cs.position === 'sticky' || cs.position === 'fixed') && !h.classList.contains('shopify-section-header-hidden')) return h.getBoundingClientRect().height;
    return 0;
  }
  function initDetails() {
    var nav = $('[data-rdp-jump]'); var desc = $('.product-single__description');
    if (desc) polishPlain(desc);
    initDocs(desc);
    if (!nav || nav.dataset.rdpBuilt) return;
    var col = nav.closest('.product-single__content-details') || nav.parentNode;
    var heads = [];
    if (desc) {
      var top = document.createElement('span'); top.className = 'rdp-anchor'; top.id = 'rdp-s-top'; desc.parentNode.insertBefore(top, desc);
      heads.push({ id: 'rdp-s-top', label: nav.dataset.rdpOverview || 'Overview', el: top });
      var cands = $$('.pd-label, .section-label, h2, h3', desc).filter(function (h) {
        if (h.closest('.pd-faq details, details, .rdp-dl')) return false;
        if (h.classList.contains('pd-label') || h.classList.contains('section-label') || /^H[23]$/.test(h.tagName)) { var t = labelOf(h); return t.length > 1 && t.length < 40 && !NAV_SKIP.test(t); }
        return false;
      });
      var seen = {};
      cands.forEach(function (h, i) {
        var t = niceLabel(labelOf(h)); var key = t.toLowerCase();
        if (seen[key]) return; seen[key] = 1;
        h.id = h.id || ('rdp-s-' + i); h.classList.add('rdp-anchor');
        heads.push({ id: h.id, label: t, el: h });
      });
    }
    $$('[data-rdp-anchor]', col).forEach(function (el, i) { el.id = el.id || ('rdp-x-' + i); el.classList.add('rdp-anchor'); heads.push({ id: el.id, label: el.getAttribute('data-rdp-anchor'), el: el }); });
    if (heads.length < 3) { nav.dataset.rdpBuilt = 'skip'; nav.remove(); return; }
    heads.forEach(function (h) {
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.label; a.dataset.rdpTarget = h.id;
      a.addEventListener('click', function (e) { e.preventDefault(); var y = h.el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 64; window.scrollTo({ top: y, behavior: 'smooth' }); });
      nav.appendChild(a);
    });
    nav.dataset.rdpBuilt = '1';
    var links = $$('a', nav); var ticking = false;
    function spy() {
      ticking = false;
      var off = headerOffset(); document.documentElement.style.setProperty('--rdp-header-h', off + 'px');
      var line = off + 80 + (nav.getBoundingClientRect().height || 0); var cur = heads[0];
      heads.forEach(function (h) { if (h.el.getBoundingClientRect().top <= line) cur = h; });
      links.forEach(function (a) { var on = a.dataset.rdpTarget === cur.id; a.classList.toggle('is-on', on); if (on && nav.scrollWidth > nav.clientWidth) { var r = a.getBoundingClientRect(), nr = nav.getBoundingClientRect(); if (r.left < nr.left || r.right > nr.right) nav.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' }); } });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  /* ---------- 4. mobile sticky add-to-cart bar → body.rdp-atc-fixed (CSS lifts the chat bubble + wishlist heart above it) ---------- */
  function initAtcWatch() {
    $$('.product-form').forEach(function (form) {
      if (form.dataset.rdpAtc) return; form.dataset.rdpAtc = '1';
      var sync = function () { document.body.classList.toggle('rdp-atc-fixed', !!$('.product-form.fix-controls-group--submit')); };
      if (window.MutationObserver) new MutationObserver(sync).observe(form, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }

  /* ---------- 5. recently viewed (localStorage rdp_recent; the section only carries the current product) ---------- */
  var RECENT_KEY = 'rdp_recent';
  function initRecent() {
    var sec = $('[data-rdp-recent]'); if (!sec || sec.dataset.rdpDone) return; sec.dataset.rdpDone = '1';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    var me = sec.dataset.rdpHandle, max = parseInt(sec.dataset.rdpMax || '8', 10) || 8, min = parseInt(sec.dataset.rdpMin || '2', 10) || 2;
    var others = list.filter(function (p) { return p && typeof p.h === 'string' && p.h !== me && typeof p.u === 'string'; });
    if (me) {
      var cur = { h: me, t: sec.dataset.rdpTitle || '', u: sec.dataset.rdpUrl || ('/products/' + me), i: sec.dataset.rdpImg || '', p: sec.dataset.rdpPrice || '', ts: Date.now() };
      try { localStorage.setItem(RECENT_KEY, JSON.stringify([cur].concat(others).slice(0, 24))); } catch (e) { }
    }
    var show = others.slice(0, max); if (show.length < min) return;
    var row = $('[data-rdp-recent-list]', sec); if (!row) return;
    show.forEach(function (p) {
      var a = document.createElement('a'); a.className = 'rdp-rcard'; a.href = p.u;
      var im = document.createElement('div'); im.className = 'rdp-rcard__img';
      if (p.i && /^(https?:)?\/\//.test(p.i)) { var img = document.createElement('img'); img.src = p.i; img.alt = p.t || ''; img.loading = 'lazy'; img.width = 480; img.height = 600; im.appendChild(img); }
      a.appendChild(im);
      var b = document.createElement('b'); b.textContent = p.t || ''; a.appendChild(b);
      if (p.p) { var sp = document.createElement('span'); sp.textContent = p.p; a.appendChild(sp); }
      row.appendChild(a);
    });
    sec.hidden = false;
    var clr = $('[data-rdp-recent-clear]', sec);
    if (clr) clr.addEventListener('click', function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) { } sec.hidden = true; });
  }

  function init() { try { initThumbs(); } catch (e) { } try { initSlabs(); } catch (e) { } try { initBuyBox(); } catch (e) { } try { initDetails(); } catch (e) { } try { initAtcWatch(); } catch (e) { } try { initRecent(); } catch (e) { } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Honey swaps product-information HTML on sibling switch → re-run (idempotent)
  var pi = document.querySelector('product-information');
  if (pi && window.MutationObserver) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 300); }).observe(pi, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 200); });
  window.__rdPdp = { init: init, v: '2.1' };
})();
